export default {
  xs: '320px',
  sm: '480px',
  md: '640px',
  lg: '800px',
  xl: '960px',
};
